// Action type
export const SET_SELECTED_INDEX = "SET_SELECTED_INDEX";

// Action creator
export const setSelectedIndex = (index) => ({
  type: SET_SELECTED_INDEX,
  payload: index,
});
